import type { ObjectShape } from 'yup';
import { date, number, object, string } from 'yup';

import { requiredFieldMessage, requiredNumberFieldMessage } from './messages';

export function requiredString(message?: string) {
  return string()
    .typeError(message || requiredFieldMessage)
    .required(message || requiredFieldMessage);
}

export function requiredNumber(message?: string) {
  return number()
    .typeError(message || requiredNumberFieldMessage)
    .required(message || requiredNumberFieldMessage);
}

export function requiredObject<T extends ObjectShape>(
  spec?: T,
  message?: string,
) {
  return object(spec).required(message || requiredFieldMessage);
}

export function requiredDate(message?: string) {
  return date().required(message || requiredFieldMessage);
}

export function optionalString() {
  return string().nullable();
}

export function optionalNumber() {
  return number().nullable();
}

export function optionalObject<T extends ObjectShape>(spec: T) {
  return object(spec).nullable();
}

export function optionalDate() {
  return date().nullable();
}
